module.exports = __webpack_public_path__ + "static/media/Gustavo.2a7b1340.jpeg";